import styled from 'styled-components'

// Each section gets its width & min-width from parent component
export const Column = styled.div`
  width: 52%;
  min-width: 656px;
  max-height: 851px;
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 9.75px;
`

export const SoapInputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const Retry = styled.img`
  width: 18px;
  height: 18px;
  // background: #10123d;
  border-radius: 10px;
  position: absolute;
  top: 9%;
  left: 97%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 10;
`

export const RetryLoading = styled.img`
  width: 18px;
  height: 18px;
  // background: #10123d;
  border-radius: 10px;
  position: absolute;
  top: 9%;
  left: 97%;
  transform: translate(-50%, -50%);
  animation: rotate 1.2s linear infinite;
  z-index: 10;
  @keyframes rotate {
    from {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }
`
